export const profile = {
  profileFavoritesIconTitle: 'Favoritos',
  profileEditIconTitle: 'Editar',
  profileShareIconTitle: 'Compartir',
  profileAdditionalSectionTitle: 'Información adicional',
  profileFavoritesCurtainTitle: 'Favoritos',
  profileFavoriteActionTitle: 'Favorito',
  profileFavoritedActionTitle: 'Añadido a favoritos',
  profileMessageAction: 'Mensaje',
  profileCurtainAdd: 'Añadir',
  profileReportUser: 'Reportar usuario',
  profileReportTitle: 'Reportar',
  profileReportSuccess: 'Contenido reportado',
  profileReset: 'Restablecer',
  profileApply: 'Aplicar',
  profileCustomInvalidEmail: 'no es una dirección de correo válida',
  profileMaxContentSizeError: '¡Has superado el tamaño máximo del contenido!',
  profileMaxAvatarSizeError: '¡El tamaño de tu avatar es demasiado grande!',
  profileFavoritesCurtainSearchInputText: 'Buscar',
  profileTapShareCurtainOptionTitle: 'Copiar enlace',
  profileTapShareLinkCopiedAlertTitle: '¡Enlace copiado!',
  profileQrShareCurtainTitle: 'Compartir perfil',
  profileQrShareCurtainShareButtonTitle: 'Compartir',
  profileQrShareCurtainCopyButtonTitle: 'Copiar enlace',
  profileQrShareCurtainCopiedAlertTitle: '¡Enlace copiado!',
  profileQrTapShareProfileCurtainTitle: 'Comparte tu perfil',
  profileEditTitle: 'Editar',
  profileEditPersonalSectionTitle: 'Detalles personales',
  profileEditContactsSectionTitle: 'Contactos',
  profileEditSocialSectionTitle: 'Redes sociales',
  profileEditAddSocialButtonTitle: 'Añadir redes sociales',
  profileEditAdditionalSectionTitle: 'Información adicional',
  profileEditSaveButtonTitle: 'Guardar',
  profileEditSavedAlertTitle: '¡Perfil guardado!',
  profileEditEmptyRequiredInputTitle: 'El valor no puede estar vacío',
  profileEditEmptyRequiredEmailInputTitle: 'El correo público no es válido',
  profileEditEmptyRequiredErrorTitle: '¡Algo salió mal!',
  profileEditSocialsHint: 'Por favor, inserta la URL de tu perfil social',
  preferences: 'Preferencias',
  interestedIn: 'Interesado en',
  expertIn: 'Soy experto en',
  myPitch: 'Mi presentación',
  qrBadge: 'Insignia QR',
  touchpoints: 'Touchpoints',
  lookingFor: 'Estoy buscando',
  topicsToDiscuss: 'Temas a discutir',
  createNew: 'Crear nuevo',
  viewTopic: 'Ver tema',
  hobbyInterests: 'Hobbies e intereses',
  myNetwork: 'Mi red',
  seeAll: 'Ver todo',
  checkThemOut: '¡Míralos!',
  activities: 'Actividades',
  oneOnOne: 'Reunión 1:1',
  Leaderboard: 'Clasificación',
  learnNetworking: 'Aprende más sobre Networking Hub',
  networkingGroup: 'Grupo de Networking',
  networkingLevel: 'Nivel de Networking',
  addNote: 'Agregar nota',
  notes: 'Notas',
  enterNote: 'Ingresar una nota',
  shareUserProfile: 'Compartir perfil de usuario',
  flagUser: 'Reportar usuario'
}
